import { Download } from "lucide-react";
import { PageFrame } from "../components/PageFrame";
import { Reveal } from "../components/Reveal";
import { clubDocuments } from "../content/siteContent";

export function DocumentsPage() {
  return (
    <PageFrame
      className="documents-page"
      label="ΑΣΟ ΩΜΕΓΑ"
      title="Έγγραφα"
      intro={<p>Επιλέξτε το έγγραφο που χρειάζεστε και κατεβάστε το.</p>}
    >
      <Reveal className="documents-panel technical-frame">
        <div className="documents-list">
          {clubDocuments.map((document, index) => (
            <article className="document-row" key={document.title}>
              <span className="document-number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
              <h2>{document.title}</h2>
              {document.fileUrl ? (
                <a className="button button--primary" href={document.fileUrl} download data-target>
                  Λήψη εγγράφου
                  <Download aria-hidden="true" />
                </a>
              ) : (
                <span className="document-unavailable" aria-label="Το έγγραφο θα είναι διαθέσιμο σύντομα">
                  Σύντομα διαθέσιμο
                </span>
              )}
            </article>
          ))}
        </div>
      </Reveal>
    </PageFrame>
  );
}
